/**
 * Converts a color from CSS hex format to CSS rgba format.
 */
export function hexToRgba(originColor: string, opacity: number = 1): string {
  const color = originColor.substr(1);

  const re = new RegExp(`.{1,${color.length / 3}}`, 'g');
  let colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(n => n + n);
  }

  if (!colors) {
    return '';
  }

  const rgb = colors.map(n => parseInt(n, 16)).join(', ');

  return `rgba(${rgb}, ${opacity})`;
}
